import {
  DATA_CARD_ONE_LOGO_DEFAULT,
  INSTITUTION_CARD_ICON,
  MINAE_CA,
  MINAE_CARD_ICON,
  MINAE_DA,
  MINAE_DE,
  MINAE_DE_2,
  MINAE_DGM,
  MINAE_FONAFIFO,
  MINAE_SINAC,
  PACA_CLIMATE_CHANGE_ICON,
  PACA_GENDER_ICON,
  PACA_GOBER_ICON,
  PACA_OTHERS_ICON,
  PACA_PERSON_ICON,
  PACA_PROSPERITY_ICON,
  PACA_SEA_ICON,
  PROJECT_CARD_ICON,
  PROJECT_MOCUPP,
  PROJECT_PACIFICO,
  RENIA_BCCR,
  RENIA_CNE,
  RENIA_ICT,
  RENIA_INCOPESCA,
  RENIA_INEC,
  RENIA_MAG,
  RENIA_MEP,
  RENIA_MIVAH,
  RENIA_MS,
} from "../assets";
import { STATISTICS_DETAIL } from "./routes";

export const FEATURED_CARDS = [
  {
    id: "0",
    title: "MINAE",
    description: "Ministerio de Ambiente y Energía",
    icon_url: "",
  },
];

export const CARD_LIST_V2 = [
  {
    id: "0",
    name: "minae.name",
    title: "minae.title",
    showOnMenu: true,
    category_id: "",
    description: "minae.description",
    icon_url: MINAE_CARD_ICON,
    open_data_link: STATISTICS_DETAIL.replace(":id", "0"),
    metadata: {
      version: "1.0.0",
      title: "minae.card.title",
      description: "minae.card.description",
    },
    elements: [
      {
        title: "minae.elements.ca.title",
        description: "minae.elements.ca.description",
        iconSrc: MINAE_CA.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21754/contraloria-ambiental-ca",
      },
      {
        title: "minae.elements.da.title",
        description: "minae.elements.da.description",
        iconSrc: MINAE_DA.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21753/direccion-de-agua-da",
      },
      {
        title: "minae.elements.de.title",
        description: "minae.elements.de.description",
        iconSrc: MINAE_DE.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21755/direccion-de-energia-de/",
      },
      {
        title: "minae.elements.de_balance.title",
        description: "minae.elements.de_balance.description",
        iconSrc: MINAE_DE_2.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21694/balance-energetico-nacional-2022",
      },
      {
        title: "minae.elements.dgm.title",
        description: "minae.elements.dgm.description",
        iconSrc: MINAE_DGM.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21752/direccion-de-geologia-y-minas-dgm/",
      },
      {
        title: "minae.elements.fonafifo.title",
        description: "minae.elements.fonafifo.description",
        iconSrc: MINAE_FONAFIFO.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21751/fondo-nacional-de-financiamiento-forestal-fonafifo/",
      },
      {
        title: "minae.elements.sinac.title",
        description: "minae.elements.sinac.description",
        iconSrc: MINAE_SINAC.default,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21750/sistema-nacional-de-areas-de-conservacion-sinac",
      },
    ],
  },
  {
    id: "1",
    name: "institutions.name",
    title: "institutions.title",
    category_id: "",
    description: "institutions.description",
    icon_url: INSTITUTION_CARD_ICON,
    open_data_link: STATISTICS_DETAIL.replace(":id", "1"),
    showOnMenu: true,
    metadata: {
      version: "1.0.0",
      title: "institutions.card.title",
      description: "institutions.card.description",
    },
    elements: [
      {
        title: "institutions.elements.bccr.title",
        description: "institutions.elements.bccr.description",
        iconSrc: RENIA_BCCR,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21763/banco-central-de-costa-rica-bccr/",
      },
      {
        title: "institutions.elements.incopesca.title",
        description: "institutions.elements.incopesca.description",
        iconSrc: RENIA_INCOPESCA,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21756/instituto-costarricense-de-pesca-y-acuicultura-incopesca",
      },
      {
        title: "institutions.elements.inec.title",
        description: "institutions.elements.inec.description",
        iconSrc: RENIA_INEC,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21762/instituto-nacional-de-estadistica-y-censos-inec",
      },
      {
        title: "institutions.elements.mag.title",
        description: "institutions.elements.mag.description",
        iconSrc: RENIA_MAG,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21761/ministerio-de-agricultura-y-ganaderia-de-costa-rica-mag",
      },
      {
        title: "institutions.elements.minsa.title",
        description: "institutions.elements.minsa.description",
        iconSrc: RENIA_MS,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21768/ministerio-de-salud-de-costa-rica-minsa",
      },
      {
        title: "institutions.elements.mivah.title",
        description: "institutions.elements.mivah.description",
        iconSrc: RENIA_MIVAH,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21757/ministerio-de-vivienda-y-asentamientos-humanos-mivah",
      },
      {
        title: "institutions.elements.cne.title",
        description: "institutions.elements.cne.description",
        iconSrc: RENIA_CNE,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21760/comision-nacional-de-prevencion-de-riesgos-y-atencion-de-emergencias-cne",
      },
      {
        title: "institutions.elements.mep.title",
        description: "institutions.elements.mep.description",
        iconSrc: RENIA_MEP,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21759/ministerio-de-educacion-publica-mep",
      },
      {
        title: "institutions.elements.ict.title",
        description: "institutions.elements.ict.description",
        iconSrc: RENIA_ICT,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21758/instituto-costarricense-de-turismo-ict",
      },
    ],
  },
  {
    id: "2",
    name: "projects.name",
    title: "projects.title",
    category_id: "",
    description: "projects.description",
    icon_url: PROJECT_CARD_ICON,
    open_data_link: STATISTICS_DETAIL.replace(":id", "2"),
    showOnMenu: true,
    metadata: {
      version: "1.0.0",
      title: "projects.card.title",
      description: "projects.card.description",
    },
    elements: [
      {
        title: "projects.elements.paca.title",
        description: "projects.elements.paca.description",
        iconSrc: PROJECT_PACIFICO,
        subitems: true,
        href: STATISTICS_DETAIL.replace(":id", "3"),
      },
      {
        title: "projects.elements.mocupp.title",
        description: "projects.elements.mocupp.description",
        iconSrc: PROJECT_MOCUPP,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21781/mocupp",
      },
    ],
  },
  {
    id: "3",
    name: "paca.name",
    title: "paca.title",
    category_id: "",
    description: "paca.description",
    icon_url: "",
    bannerImageSrc: DATA_CARD_ONE_LOGO_DEFAULT,
    whereWorkdShow: true,
    open_data_link: "",
    showOnMenu: false,
    metadata: {
      version: "1.0.0",
    },
    elements: [
      {
        title: "paca.elements.climate_change.title",
        description: "paca.elements.climate_change.description",
        iconSrc: PACA_CLIMATE_CHANGE_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21764/cambio-climatico",
      },
      {
        title: "paca.elements.gender.title",
        description: "paca.elements.gender.description",
        iconSrc: PACA_GENDER_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21765/genero",
      },
      {
        title: "paca.elements.people.title",
        description: "paca.elements.people.description",
        iconSrc: PACA_PERSON_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21744/personas",
      },
      {
        title: "paca.elements.prosperity.title",
        description: "paca.elements.prosperity.description",
        iconSrc: PACA_PROSPERITY_ICON,
        subitems: false,
        href: "http://ceniga.opendata.junar.com/dashboards/21766/prosperidad",
      },
      {
        title: "paca.elements.sea_coasts.title",
        description: "paca.elements.sea_coasts.description",
        iconSrc: PACA_SEA_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21767/mares-y-costas",
      },
      {
        title: "paca.elements.governance.title",
        description: "paca.elements.governance.description",
        iconSrc: PACA_GOBER_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21743/gobernanza",
      },
      {
        title: "paca.elements.other_resources.title",
        description: "paca.elements.other_resources.description",
        iconSrc: PACA_OTHERS_ICON,
        subitems: false,
        href: "https://ceniga.opendata.junar.com/dashboards/21782/paca-mapas",
      },
    ],
  },
];

export const CARD_LIST = [
  {
    metadata: {
      version: "1.0.0",
    },
    description: "Listado de los indicadores relacionados con el océano",
    id: "16f84d34-e4c7-44a5-82e5-ec8a4492450f",
    name: "Océano",
    category_id: "16f84d34-e4c7-44a5-82e5-ec8a4492450f",
    icon_url:
      "https://indicator-data.s3.us-east-1.amazonaws.com/icon/oceano+1.svg",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21693/oceano/",
  },
  {
    metadata: null,
    description: "",
    id: "3bd19b0e-452d-453b-a577-819e57091b02",
    name: "Agua y Saneamiento",
    icon_url: "https://indicator-data.s3.amazonaws.com/icon/agua_icon.svg",
    category_id: "3bd19b0e-452d-453b-a577-819e57091b02",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21690/agua-y-saneamiento/",
  },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con acciones por el clima",
  //   "id": "2336217d-3300-4c35-8b2b-d78b526f7cb0",
  //   "name": "Acción por el clima",
  //   "category_id": "2336217d-3300-4c35-8b2b-d78b526f7cb0"
  // },
  {
    metadata: null,
    description: "",
    id: "6032cbe8-b299-453f-81aa-5c13efffeec5",
    name: "Biodiversidad y servicios ecosistémicos",
    icon_url: "https://indicator-data.s3.amazonaws.com/icon/ecosistema.svg",
    category_id: "6032cbe8-b299-453f-81aa-5c13efffeec5",
    open_data_link:
      "https://ceniga.opendata.junar.com/dashboards/21697/biodiversidad-y-servicios-ecosistemicos/",
  },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con producción y consumo sostenible",
  //   "id": "e46a96ae-e932-46af-90bf-92f61b457042",
  //   "name": "Producción y consumo sostenible",
  //   "category_id": "e46a96ae-e932-46af-90bf-92f61b457042"
  // },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con energía y descarbonización",
  //   "id": "163fcd0f-060c-4191-aa1b-894e76232dad",
  //   "name": "Energía y descarbonización",
  //   "category_id": "163fcd0f-060c-4191-aa1b-894e76232dad"
  // },
  // {
  //   "metadata": null,
  //   "description": "",
  //   "id": "992fc9c5-4aee-44aa-b3de-91b8052d2876",
  //   "name": "Ciudades y comunidades",
  //   "icon_url": "https://indicator-data.s3.amazonaws.com/icon/industria.svg",
  //   "category_id": "992fc9c5-4aee-44aa-b3de-91b8052d2876"
  // },
  // {
  //   "metadata": {
  //     "version": "1.0.0"
  //   },
  //   "description": "Listado de los indicadores relacionados con recursos geológicos",
  //   "id": "d3d40f1a-a0eb-4d1f-af04-ea849fbb2139",
  //   "name": "Recursos geológicos",
  //   "category_id": "d3d40f1a-a0eb-4d1f-af04-ea849fbb2139"
  // }
];
